'use strict';
import React from 'react';
import { Link } from 'react-router-dom';
import leaveSetAction from '../../actions/leaveSetAction';
import leaveSetStore from '../../stores/leaveSetStore';
import LeaveSetModal from './leaveSetModal';

class LeaveSetForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleEditUsed = this.handleEditUsed.bind(this);
        this.handleBringFwd = this.handleBringFwd.bind(this);
        this.handleMaxBringFwd = this.handleMaxBringFwd.bind(this);
        this.handleLeaveGain = this.handleLeaveGain.bind(this);
        this.removeType = this.removeType.bind(this);
        this.shouldModalClose = this.shouldModalClose.bind(this);
        this.onChange = this.onChange.bind(this);
        this.state = {
            leaves: leaveSetStore.getState().leaves,
            processing: leaveSetStore.getState().processing,
            maxBringFwd: leaveSetStore.getState().maxBringFwd,
            action: "",
            type: "",
            modalClose: false,
        };
    }
    static defaultProps = {
        typeTxt: ["Annual Leave", "Medical Leave", "Reservist", "Childcare leave", "Unpaid leave", "Compassionate leave", "Other Leave", "Time-off", "Tele-commuting"],
    };
    componentDidMount() {
        leaveSetStore.listen(this.onChange);
        if (!this.state.processing) {
            leaveSetAction.processing(true);
            leaveSetAction.getLeaveTotal(this.props.staffId);
            leaveSetAction.getMaxBringFwd();
        }
    }
    componentWillUnmount() {
        leaveSetStore.unlisten(this.onChange);
    }
    onChange(state) {
        this.setState({
            leaves: state.leaves,
            processing: state.processing,
            maxBringFwd: state.maxBringFwd,
        });
    }
    shouldModalClose(data) {
        this.setState({ modalClose: data });
    }
    handleClick(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        if (index == 1) {
            return leaveSetAction.updating(false);
        } else if (index == 2) {
            return this.setState({
                modalClose: true,
                action: 1
            });
        }
        if (this.state.processing) return;

        leaveSetAction.processing(true);
        leaveSetAction.updateLeaveTotal(this.props.staffId, this.state.leaves, this.state.maxBringFwd);

    }
    handleEdit(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        let value = parseFloat(e.target.value);
        leaveSetAction.totalGain({ type: index, value: value });
    }
    handleEditUsed(e) {
        let index = parseInt(e.target.getAttribute('data-index'));
        let value = parseFloat(e.target.value);
        leaveSetAction.used({ type: index, value: value });
    }
    handleBringFwd(e) {
        let value = parseFloat(e.target.value);
        leaveSetAction.bringFwd({ type: 0, value: value });
    }
    handleMaxBringFwd(e) {
        let value = parseFloat(e.target.value);
        leaveSetAction.maxBringFwd(value);
    }
    handleLeaveGain(e) {
        let value = parseFloat(e.target.value);
        leaveSetAction.leaveGain({ type: 0, value: value });

    }
    removeType(e) {
        let type = parseInt(e.currentTarget.getAttribute('data-type'));
        this.setState({
            action: 0,
            type: type,
            modalClose: true
        });
    }
    renderInput() {
        let inputTxt = '', bringFwd, leaveGain;
        inputTxt = this.state.leaves
        .sort((a,b)=>{
            return (a.type - b.type);
        })    
        .map((leave, index) => {
            if (leave.type == 0) {
                bringFwd = (
                    <input type="number" className="form-control" id="ls-fwd" key={index}
                        data-index={leave.type} value={leave.bringFwd} onChange={this.handleBringFwd} />
                );

                leaveGain = (
                    <input type="number" className="form-control" id="ls-lg" key={index}
                        data-index={leave.type} value={leave.leaveGain} onChange={this.handleLeaveGain} />
                );
            }
            return (
                <div className="row" key={index}>
                    <div className="col-sm-2">
                        <div className="form-group">
                            <div className="ls-t-wp">
                                <label htmlFor={"ls-" + index}>{leave.leaveTxt}</label>
                                {leave.type > 9 ?
                                    <button className="btn btn-danger btn-xs ls-rm" data-type={leave.type} onClick={this.removeType}>Remove</button>
                                    :
                                    ""
                                }
                            </div>
                            <input type="number" className="form-control" id={"ls-" + index}
                                data-index={leave.type} value={leave.totalGain} onChange={this.handleEdit} />
                        </div>
                    </div>
                    <div className="col-sm-2">
                        <label htmlFor="ls-lg">Used ({leave.type != 7 ? "days" : "hours"})</label>
                        <input type="number" className="form-control" id={"ls-" + index}
                            data-index={leave.type} value={leave.used} onChange={this.handleEditUsed} />
                    </div>
                    {leave.type == 0 ?
                        <div className="col-sm-2">
                            <label htmlFor="ls-fwd">Bring Forward</label>
                            {bringFwd}
                        </div>
                        : ""}
                    {leave.type == 0 ?
                        <div className="col-sm-2">
                            <label htmlFor="ls-lg">Leave Gain</label>
                            {leaveGain}
                        </div>
                        : ""}
                    {leave.type == 0 ?
                        <div className="col-sm-3">
                            <label htmlFor="mx-fwd">Maximum Bring Forward day (Apply to All)</label>
                            <input type="number" className="form-control" id="mx-fwd"
                                value={this.state.maxBringFwd} onChange={this.handleMaxBringFwd} />
                        </div>
                        : ""}
                </div>
            );
        });
        return inputTxt;
    }
    render() {

        let modal;
        if (this.state.modalClose) {
            modal = (
                <LeaveSetModal action={this.state.action} shouldModalClose={this.shouldModalClose} modalClose={this.state.modalClose}
                    type={this.state.type} processing={this.state.processing} />
            );
        }
        return (
            <div className="lv-wp">
                <h4>{this.props.userName + " (" + this.props.staffId + ")"}'s Leave Setting</h4>
                {this.renderInput()}

                <div className="row">
                    <div className="col-sm-12">
                        <button type="button" className="btn btn-default us-cr" data-index="0" onClick={this.handleClick}>Save</button>
                        <button type="button" className="btn btn-default us-cr" data-index="1" onClick={this.handleClick}>Back</button>
                        <button type="button" className="btn btn-warning us-cr" data-index="2" onClick={this.handleClick}>Add new type of Leave</button>
                    </div>
                </div>
                {modal}
            </div>
        );
    }
}
export default LeaveSetForm;


// WEBPACK FOOTER //
// ./app/setComponents/leaveSetComponents/leaveSetForm.js